import { ReactElement } from 'react';
import { BigNumberCard } from './components/Card';
import { t } from 'i18next';
import { GenericDescriptionTooltipContent } from './styles';

export function HvacEnergy({ loading }: Readonly<{ loading: boolean }>): ReactElement {
  return (
    <BigNumberCard
      id="hvac-energy"
      icon="LightningIcon"
      number="-"
      description={{
        text: t('economiaDeEnergiaHvac'),
        tooltip: <HvacEnergyTooltip />,
      }}
      subDescription={{
        number: 0,
        text: t('kWhDeEconomia'),
      }}
      loading={loading}
      disabledTooltip={false}
      indicatorColor="transparent"
      comingSoon
      dataTestId="big-number-card-hvac-energy"
    />
  );
}

function HvacEnergyTooltip() {
  return (
    <GenericDescriptionTooltipContent>
      <span>{t('emBreveVocePoderaAcompanharSuaEconomiaDeEnergiaHvac')}</span>
    </GenericDescriptionTooltipContent>
  );
}
